<template>
  <div class="abteilung-instance abteilung col-12" :class="cssClass">
    <table>
      <tr>
        <th colspan="2" title="Abteilung" class="text-center bg-blue color-white" v-html="abteilung.titel"></th>
      </tr>
      <tr v-if="abteilung.terminvergabe">
        <th>Terminvergabe</th>
        <td v-html="abteilung.terminvergabe"></td>
      </tr>
      <tr v-if="abteilung.aufnahme">
        <th>Anfrage Stationäre Aufnahme</th>
        <td v-html="abteilung.aufnahme"></td>
      </tr>
      <tr v-for="feld in abteilung.zusatzFelder" :key="feld.key + feld.value">
        <th v-html="feld.key" :colspan="!feld.value ? 2 : 1"></th>
        <td v-html="feld.value" v-if="feld.value"></td>
      </tr>
      <tr v-if="abteilung.sonstiges">
        <td v-html="abteilung.sonstiges" colspan="2"></td>
      </tr>
      <tr v-if="abteilung.betriebszeiten">
        <th>Betriebszeiten</th>
        <td v-html="abteilung.betriebszeiten"></td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: "AbteilungInstance",
  props: ["abteilung", "cssClass"]
}
</script>
